<template>
  <span
    class="app-badge"
    :class="badgeClasses"
    :role="pulse ? 'status' : undefined">
    <span
      v-if="dot"
      class="app-badge__dot"
      aria-hidden="true">
      <span v-if="pulse" class="app-badge__dot-ping" />
      <span class="app-badge__dot-core" />
    </span>

    <i
      v-if="icon"
      :class="icon"
      class="app-badge__icon"
      aria-hidden="true" />

    <slot />

    <button
      v-if="removable"
      type="button"
      class="app-badge__remove"
      :aria-label="removeLabel"
      @click="emit('remove')">
      <i class="fa-solid fa-xmark" aria-hidden="true" />
    </button>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'neutral',
    validator: (value) => ['success', 'warning', 'danger', 'primary', 'neutral', 'purple'].includes(value)
  },
  size: {
    type: String,
    default: 'sm',
    validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value)
  },
  shape: {
    type: String,
    default: 'pill',
    validator: (value) => ['pill', 'rounded', 'subtle', 'square'].includes(value)
  },
  outline: {
    type: Boolean,
    default: false
  },
  dot: {
    type: Boolean,
    default: false
  },
  pulse: {
    type: Boolean,
    default: false
  },
  icon: {
    type: String,
    default: ''
  },
  removable: {
    type: Boolean,
    default: false
  },
  removeLabel: {
    type: String,
    default: 'Remove'
  }
})

const emit = defineEmits(['remove'])

const badgeClasses = computed(() => [
  `app-badge--${props.variant}`,
  `app-badge--${props.size}`,
  `app-badge--${props.shape}`,
  {
    'app-badge--outline': props.outline,
    'app-badge--with-dot': props.dot,
    'app-badge--with-icon': props.icon,
    'app-badge--removable': props.removable
  }
])
</script>
